<div class="sc-policy-info">
  <sc-title type="h2" content="Información de la póliza" color="black"></sc-title>
  <p class="section-subtitle">Podés completar el resto de la información a la hora de emitir</p>
  <ng-container *ngIf="!loading">
    <form [formGroup]="form" *ngIf="editMode">
      <div class="fields-block">
        <div class="row">
          <div class="col-12">
            <sc-select
              *ngIf="!hideAffinityGroups"
              formControlName="affinityGroupsFormControl"
              label="Grupos de afinidad"
              objectKey="publicId"
              objectValue="displayName"
              [itemsAsync$]="affinityGroups$"
              (optionSelected)="handleAffinityGroupsSelect($event)"
            ></sc-select>
            <sc-select
              formControlName="term"
              label="Vigencia"
              [items]="termOptions"
              [isDisabled]="termOptionsDisabled"
              (optionSelected)="setExpirationDate(null, $event.key)"></sc-select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <sc-simple-date-picker
              formControlName="effectiveDate"
              label="Inicio"
              [minLimitDateFromNow]="backwardDays"
              [maxLimitDateFromNow]="DIFFERENCE_FORWARD"
            ></sc-simple-date-picker>
          </div>
          <div class="col-md-6 col-12">
            <sc-simple-date-picker formControlName="expirationDate" label="Fin" [readonly]="true"></sc-simple-date-picker>
          </div>
        </div>
        <div class="row" *ngIf="!hideAutomaticAdjustment">
          <div class="col-md-6 col-12">
            <sc-select  formControlName="automaticAdjustment"
                        label="Ajuste automático"
                        objectKey="code"
                        objectValue="name"
                        [itemsAsync$]="automaticAdjustmentOptions$"></sc-select>
          </div>
        </div>
        <div class="row" *ngIf="!hidePremiumDiscount">
          <div class="premium-discount-wrapper col-md-9 col-12">
            <sc-select  formControlName="premiumDiscount"
                        label="Alternativa comercial"
                        objectValue="name"
                        placeholder="Sin modificación en la prima"
                        [loading]="premiumDiscountsLoading"
                        [itemsAsync$]="premiumDiscountOptions$"
                        (optionSelected)="handlePremiumDiscountOptionSelected($event)"></sc-select>
            <sc-tooltip
              *ngIf="premiumDiscountLimit && hasUnderWritingFlag"
              class="under-writing-indicator"
              title="Este descuento requiere aprobación"
              [externallyOpen]="hasUnderWritingFlag"
              [description]="underWritingMessage"
            >
              <sc-icon class="under-writing-indicator__icon" icon="alert-elipse-copy"></sc-icon>
            </sc-tooltip>
          </div>
        </div>
      </div>
      <div class="buttons-block">
        <sc-button
          id="policy-info-calculate-price"
          size="small"
          type="primary"
          text="Calcular precio"
          (onClick)="onSubmit()"
          [disabled]="form.invalid"
          [loading]="!canContinue || premiumDiscountsLoading"
        ></sc-button>
      </div>
    </form>
  </ng-container>
  <div class="loader" *ngIf="loading">
    <sc-icon icon="loading" size="2"></sc-icon>
  </div>
</div>
